import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface CompletedTileType {
  title: string;
  description: string;
  image: string;
  link?: string;
  onButtonClick: () => void;
}

const CompletedTile: React.FC<CompletedTileType> = ({
  title,
  description,
  image,
  link,
  onButtonClick,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "8px",
        padding: "12px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Box
          sx={{
            height: "40px",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 400,
              lineHeight: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            height: {
              xs: "150px",
              md: "200px",
            },
            width: "100%",
            marginTop: "20px",
            marginBottom: "12px",
          }}
        >
          <img
            src={image}
            alt="completed project"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </Box>

        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 300,
            lineHeight: 1.2,
          }}
        >
          {description}
        </Typography>
      </Box>

      <Button
        onClick={onButtonClick}
        variant="outlined"
        sx={{
          width: "100%",
          marginTop: "20px",
        }}
      >
        {link ? "Learn More" : "Read the Paper"}
      </Button>
    </Box>
  );
};

export default CompletedTile;
